import React, { PropsWithChildren } from 'react';
import { Card, CardBody, CardHeader, Button, Badge, Alert } from 'reactstrap';
import MyChoicesPDF from '../../../../containers/Modals/MyChoicesPDF';
import { PatientContext } from '../../../../contexts/patient';
import { IQuestionnaireResponse } from '../../../../modules/unsw-fhir/QuestionnaireResponse';
import { IQuestionnaire } from '../../../../modules/unsw-fhir/Questionnaire';
import { PDFDownloadLink } from '@react-pdf/renderer';
import PDFQuestionnaire from '../../../../containers/PdfGenerator';

const MyChoicesReportComponent = ({
  children,
  onComplete,
  practitionerDisplayName,
  patientContext,
  questionnaireResponses,
  questionnaires,
  show,
  handleShow,
  handleClose,
}: PropsWithChildren<{
  onComplete: () => void;
  practitionerDisplayName: string;
  patientContext: PatientContext;
  questionnaireResponses: {
    data: IQuestionnaireResponse[];
    isLoading: boolean;
    isError: boolean;
  };
  questionnaires: {
    data: IQuestionnaire[];
    isLoading: boolean;
    isError: boolean;
  };
  show: boolean;
  handleShow: () => void;
  handleClose: () => void;
}>) => {
  return (
    <Card>
      <MyChoicesPDF
        show={show}
        handleClose={handleClose}
        patientContext={patientContext}
        questionnaireResponses={questionnaireResponses}
        questionnaires={questionnaires}
      />
      <CardHeader>
        <Button color="primary" onClick={handleShow}>
          Open PDF
        </Button>
      </CardHeader>
      <CardBody>{children}</CardBody>

      <CardBody>
        <Alert className="lead" color="warning">
          Do you <Badge>{practitionerDisplayName}</Badge> agree that these forms
          accurately record information given in the interview involving{' '}
          <Badge>{patientContext.getDisplayName()}</Badge>
          <Button
            onClick={onComplete}
            style={{ margin: '10px', padding: '0px' }}>
            <PDFDownloadLink
              className="btn btn-secondary"
              style={{ color: 'white' }}
              document={
                <PDFQuestionnaire
                  questionnaireResponses={questionnaireResponses}
                  questionnaires={questionnaires}
                  birthDate={patientContext.getDateOfBirth()}
                  displayName={patientContext.getDisplayName()}
                  mrn={patientContext.getMrn()}
                />
              }
              fileName={patientContext.getDisplayName() + ' Responses.pdf'}>
              {({ url, loading }) => {
                console.log(url);
                return loading
                  ? 'Loading document...'
                  : 'I Agree & Download PDF';
              }}
            </PDFDownloadLink>
          </Button>
        </Alert>
      </CardBody>
    </Card>
  );
};

export default MyChoicesReportComponent;
